import axios from 'axios'

const Transparex = axios.create({
  baseURL: 'https://formular.transparex.sk/api',
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  }
})

export default Transparex
